export enum SupportChatTypifications {
  PARTNER_ORDER_WITHOUT_SK = 'PARTNER_ORDER_WITHOUT_SK',
  PARTNER_PRODUCT_TOPPING_NOT_AVAILABLE = 'PARTNER_PRODUCT_TOPPING_NOT_AVAILABLE',
  PARTNER_SK_DELAY = 'PARTNER_SK_DELAY',
}
